<template>
	<div
		@click.prevent="$emit('click', coluna.campo)"
		style="display: flex; align-items: center; cursor: pointer"
	>
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			style="width: 18px; heigth: 18px; margin-left: -6px"
			v-show="ordenacao.coluna != coluna.campo"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
			/>
		</svg>
		<svg
			v-show="ordenacao.coluna == coluna.campo && ordenacao.sentidoCrescente"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			style="width: 18px; heigth: 18px; margin-left: -6px"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M15.75 17.25L12 21m0 0l-3.75-3.75M12 21V3"
			/>
		</svg>
		<svg
			v-show="ordenacao.coluna == coluna.campo && !ordenacao.sentidoCrescente"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			stroke-width="1.5"
			stroke="currentColor"
			style="width: 18px; heigth: 18px; margin-left: -6px"
		>
			<path
				stroke-linecap="round"
				stroke-linejoin="round"
				d="M8.25 6.75L12 3m0 0l3.75 3.75M12 3v18"
			/>
		</svg>

		<small style="color: white; margin-top: 2px">{{ coluna.nome }}</small>
	</div>
</template>

<script>
export default{
  props:{
    coluna:{
      required:true,
      type:Object
    },
    ordenacao:{
      required:true,
      type:Object
    },
  },

}


</script>